import {
  Location,
  LocationPreset,
  projectViewUserLocations,
} from '../project-view-users';
import { UsersLocation } from './users-location.model';

export interface GenerateUsersLocationOptions {
  readonly userId: number;
  readonly location?: Location;
}

export function generateUsersLocationObject({
  userId,
  location = projectViewUserLocations[LocationPreset.SEATTLE],
}: GenerateUsersLocationOptions): UsersLocation {
  return {
    id: userId,
    location,
  };
}
